// Generated by scripts/build-frontend.js. Do not edit manually.
export const VERSION = '1.0.1';
export const BUILD = 8;
export const BUILD_CODE = 10108;
export const DISPLAY_VERSION = '1.0.1.10108';
export const BUILD_VERSION = VERSION;
export const BUILD_NUMBER = BUILD;
export const BUILD_VERSION_TEXT = DISPLAY_VERSION;
